import { SyncLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import NoDataPrompt from "../NoDataPrompt/NoDataPrompt";
import "./Table.css";

function toCurrency(numberString) {
    let number = parseFloat(numberString);
    return number.toLocaleString('USD');
}

const parseDate = (dateString) => {
    if (dateString === 'None' || dateString === 'N/A') {
        return null;
    }

    const parts = dateString.split('-');
    const month = parseInt(parts[0]);
    const day = parseInt(parts[1]);
    const year = parseInt(parts[2]);

    return new Date(year, month - 1, day);
};

export default function Table({
    tableHeaders,
    headerSelector,
    tableData,
    tableType,
    ActionBtn,
    DoneBtn,
    PendingBtn,
    ViewBtn,
    newTabBtn,
    showLoader,
    withActionData,
    PayBtn,
    // hasPending=false
}) {
    const columns = tableHeaders.map((header, index) => {
        if (header === "-") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: ViewBtn,
                width: "8rem",
                reorder: false,
            };
        } else if (header === "*") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: PayBtn,
                width: "8rem",
                reorder: false,
            };
        } else if (header === "PRINT TEMPLATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "TRADE NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "UNIT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                left: true,
                reorder: true,
                wrap: true,
            };
        } else if (header === "PRICE LEVEL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                left: true,
                reorder: true,
                wrap: true,
            };
        } else if (header === "SELLING PRICE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                left: true,
                reorder: true,
                wrap: true,
            };
        } else if (header === "WHOLESALE PRICE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "10rem",
                left: true,
                reorder: true,
                wrap: true,
            };
        } else if (header === "RETAIL PRICE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                left: true,
                reorder: true,
                wrap: true,
            };
        } else if (header === "TRADE ADDRESS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "PHONE NO") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "CREDIT LIMIT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "VAT TYPE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "QUOTATION DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DLVRY DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DOC. NO") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "CUSTOMER") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "BARCODE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "INHOUSE BARCODE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "TAG") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DESCRIPTION") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "ADDED ON") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "SALES TYPE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "SERIAL NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "BRANCH") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "TOTAL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "STATUS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DETAILS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "CONTACT NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "ORDER DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "SALES DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        // } else if (header === "INV NO.") {
        //     return {
        //         name: header,
        //         selector: (row) => row[headerSelector[index]],
        //         left: true,
        //         width: "8rem",
        //         reorder: true,
        //     };
        } else if ((header === "INV NO.") && tableType === "purchase return") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: newTabBtn,
                width: "8rem",
                reorder: false,
                wrap: true,
            };
        } else if (header === "INV NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: newTabBtn,
                width: "8rem",
                reorder: false,
                wrap: true,
            };
        } else if (header === "RECEIVED DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "INVOICES APPLIED") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: newTabBtn,
                width: "8rem",
                reorder: false,
                wrap: true,
            };
        } else if (header === "RETURN DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "FROM") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PAID AMNT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "BALANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } if (header === "/") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: DoneBtn,
                width: "8rem",
                reorder: false,
                wordWrap: "break-word",
            };
        } else if (header === "DATE ISSUED") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PAYEE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "AMT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PYMNT MODE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "APPLIED TO THE FF INVOICES") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DATE ADDED") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DOC NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "CURRENT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PR NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "REQUEST DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DEPARTMENT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "REQUESTED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PREPARED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "APPROVED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PO NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PURCHASE DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "NOTED BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PO DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "COMPLETED ON") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PMT STATUS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PMT REF NO" || header === "PMT MODE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: newTabBtn,
                width: "8rem",
                reorder: false,
                wrap: true,
            };
        } else if (header === "PREP. BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "APPR. BY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "1-30") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "31-60") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "61-90") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "ABOVE 90") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "TO") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "DR NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "SUBTOTAL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "AMOUNT DUE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "AMT. PAID") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "BAL.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "PYMNT STATS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "RETURN DETAILS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: PendingBtn,
                width: "8rem",
                reorder: false,
                wrap: true,
            };
        } else if (header === "AMT PAID") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "BAL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "OVERPAID AMT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "RETURN NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "REPLACEMENT NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if ((header === "REPLACEMENT ID") && tableType === "purchase return") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: PendingBtn,
                width: "8rem",
                reorder: false,
                wrap: true,
            };
        } else if (header === "CLASSIFICATION") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "30vw",
                reorder: true,
            };
        } else if (header === "USERNAME") {
            return {
                name: header,
                selector: (row) =>
                    row[headerSelector[index]] !== null
                        ? row[headerSelector[index]].toLowerCase()
                        : "",
                left: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "FRANCHISE DATE") {
            return {
                name: header,
                selector: (row) =>
                    row[headerSelector[index]] !== null
                        ? row[headerSelector[index]]
                        : "",
                button: true,
                width: "10vw",
                sortable: true,
                reorder: true,
            };
        } else if (header === "ADDRESS") {
            return {
                name: header,
                selector: (row) =>
                    row[headerSelector[index]] !== null
                        ? row[headerSelector[index]]
                        : "",
                button: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "FRANCHISEE") {
            return {
                name: header,
                selector: (row) =>
                    row[headerSelector[index]] !== null
                        ? row[headerSelector[index]]
                        : "",
                left: true,
                width: "8rem",
                reorder: true,
                sortable: true,
            };
        } else if (header === "PACKAGE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.franchisee_package.replaceAll(',', ''));
                    const valueB = parseFloat(b.franchisee_package.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "TOTAL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.grand_total.replaceAll(',', ''));
                    const valueB = parseFloat(b.grand_total.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PAID AMOUNT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.paid_amount.replaceAll(',', ''));
                    const valueB = parseFloat(b.paid_amount.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "BALANCE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.balance.replaceAll(',', ''));
                    const valueB = parseFloat(b.balance.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "CREDIT LIMIT") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.beginning_credit_limit.replaceAll(',', ''));
                    const valueB = parseFloat(b.beginning_credit_limit.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PRICE 1") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.price_1.replaceAll(',', ''));
                    const valueB = parseFloat(b.price_1.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PRICE 2") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.price_2.replaceAll(',', ''));
                    const valueB = parseFloat(b.price_2.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "PRICE 3") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseFloat(a.price_3.replaceAll(',', ''));
                    const valueB = parseFloat(b.price_3.replaceAll(',', ''));

                    
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "OPEN DATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.opening_start);
                    const valueB = parseDate(b.opening_start);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "CNTRCT END") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "10vw",
                right: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    
                    
                    const valueA = parseDate(a.contract_end);
                    const valueB = parseDate(b.contract_end);

                    
                    if (valueA === null && valueB === null) {
                        return 0;
                    }
                    if (valueA === null) {
                        return -1;
                    }
                    if (valueB === null) {
                        return 1;
                    }
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            };
        } else if (header === "BRANCH NAME") {
            return {
                name: header,
                left: true,
                selector: (row) =>
                    row[headerSelector[index]] !== null
                        ? row[headerSelector[index]]
                        : "",
                // button: true,
                width: "8rem",
                reorder: true,
                sortable: true,
            };
        } else if (header === "ACTIONS" && !withActionData) {
            return {
                name: header,
                button: true,
                cell: ActionBtn,
                width: "8rem",
                reorder: true,
            };
        } else if (header==="ACCOUNT NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                sortable: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header.includes("NO.")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                sortable: true,
                width: "7vw",
                reorder: true,
            };
        } else if (header.includes("SUPPLIER")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
            };
        // } else if (
        //     header.includes("DATE")||
        //     header.includes("CNTRCT END")
        //     ) {
        //     return {
        //         name: header,
        //         selector: (row) => row[headerSelector[index]],
        //         center: true,
        //         sortable: true,
        //         width: "10vw",
        //         reorder: true,
        //     };
        } else if (
            header.includes("AMOUNT")||
            header.includes("CREDIT")||
            header.includes("BALANCE")||
            header.includes("TOTAL")||
            header.includes("PACKAGE")||
            header.includes("DOC. NO")||
            header.includes("INVCE NO.")||
            header.includes("PRICE")
        ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                sortable: true,
                width: "10vw",
                reorder: true,
            };
    
        } else if (
            header.includes("NAME") ||
            header.includes("ADDRESS") ||
            header.includes("PRINT TEMPLATE") ||
            header.includes("BANK NAME") ||
            header.includes("FULL NAME") ||
            header.includes("DEPARTMENT/BRANCH") ||
            header.includes("CONTACT NO.") ||
            header.includes("EMAIL") ||
            header.includes("POSITION") ||
            header.includes("USERNAME") ||
            // header.includes("ITEM DESCRIPTION") ||
            header.includes("BRANCH NAME")
        ) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                sortable: true,
                width: "8rem",
                reorder: true,
            };
        } else if (header === "ITEM DESCRIPTION" || header === "CATEGORY AND SUBCATEGORY") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
            };
        } else if (header === "ITEM NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "20rem",
                reorder: true,
                left: true,
                wrap: true,
                wordWrap: "break-word",
            };
        } else if (header.includes("ITEM NAME")) {
            return {
              name: header,
              selector: (row) => row[headerSelector[index]],
              sortable: true,
              width: "20rem",
              reorder: true,
              left: true,
              wrap: true,
              wordWrap: "break-word",
            }
        } else if (header === "PMT REF NO") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: newTabBtn,
                width: "8%",
                reorder: false,
                wrap: true,
            };
        } else if (header === "SALES INVOICES") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: PendingBtn,
                width: "8%",
                reorder: false,
                wrap: true,
            };
        } else {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                sortable: true,
                width: "10vw",
                reorder: true,
                wrap: true,
                wordWrap: "break-word",
            };
        } 
    });

    const paginationComponentOptions = {
        rowsPerPageText: "",
        noRowsPerPage: true,
    };

    const customStyles = {
        rows: {
            style: {
                minHeight: "5.2vh",
            },
        },
    };

    // //
    //
    //
    return showLoader ? (
        <div className="d-flex justify-content-center my-5">
            <SyncLoader color="var(--primary-color)" size={15} />
        </div>
    ) : (
        <DataTable
            pagination
            striped
            fixedHeader
            fixedHeaderScrollHeight="50vh"
            columns={columns}
            data={tableData}
            customStyles={customStyles}
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent={<NoDataPrompt />}
        />
    );
}
